// Google Maps API loader utility

import { envVars } from "./env/schema";

let googleMapsPromise: Promise<void> | null = null;

export const loadGoogleMaps = (): Promise<void> => {
	if (googleMapsPromise) {
		return googleMapsPromise;
	}

	const apiKey = envVars.VITE_MAPS_API_KEY;

	if (!apiKey) {
		return Promise.reject(new Error("Google Maps API key is missing"));
	}

	googleMapsPromise = new Promise((resolve, reject) => {
		// Create script element
		const script = document.createElement("script");
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
		script.async = true;
		script.defer = true;

		// Set callbacks
		window.initGoogleMaps = () => {
			resolve();
		};

		script.onerror = () => {
			reject(new Error("Failed to load Google Maps API"));
		};

		// Add callback parameter
		script.src += "&callback=initGoogleMaps";

		// Add to document
		document.head.appendChild(script);
	});

	return googleMapsPromise;
};

// Add to window object
declare global {
	interface Window {
		initGoogleMaps: () => void;
	}
}
